"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var layers_1 = require("../layers");
var shared_1 = require("@cian/peperrors/shared");
var RequestMonitor = /** @class */ (function () {
    function RequestMonitor(options) {
        this.httpAdapter = options.httpAdapter;
        this.requestConfig = options.requestConfig;
        this.badStatusCode = new layers_1.BadStatusCode(options.badStatusCodeConfig);
        this.telemetry = new layers_1.RequestTelemetry({
            telemetry: options.telemetryLogger,
            host: options.requestConfig.uri.host,
            path: options.requestConfig.uri.path,
        });
        this.timeout = new layers_1.RequestTimeout(options.timeoutConfig);
        this.circuitBreaker = new layers_1.RequestCircuitBreaker(options.circuitBreakerConfig, this.requestConfig);
        this.cancellationToken = options.cancellationToken;
    }
    RequestMonitor.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeoutPromise, requestPromise, response, exc_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this.telemetry.onRequest();
                        this.circuitBreaker.onRequest();
                        timeoutPromise = this.timeout.onRequest(this.requestConfig.uri);
                        if (!(this.cancellationToken && this.cancellationToken.isCanceled())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cancellationToken.toPromise()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        requestPromise = this.httpAdapter.send();
                        return [4 /*yield*/, Promise.race(this.cancellationToken
                                ? [timeoutPromise, requestPromise, this.cancellationToken.toPromise()]
                                : [timeoutPromise, requestPromise])];
                    case 3:
                        response = (_a.sent());
                        this.timeout.onResponse();
                        this.circuitBreaker.onResponse();
                        this.badStatusCode.onResponse(this.requestConfig.uri, response.responseStatusCode);
                        this.telemetry.onResponse();
                        return [2 /*return*/, response];
                    case 4:
                        exc_1 = _a.sent();
                        if (exc_1 instanceof shared_1.HttpTimeoutError || exc_1 instanceof shared_1.HttpCancelError) {
                            this.httpAdapter.abort();
                        }
                        this.telemetry.onError(exc_1);
                        this.circuitBreaker.onError(exc_1);
                        throw exc_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return RequestMonitor;
}());
exports.RequestMonitor = RequestMonitor;
//# sourceMappingURL=requestMonitor.js.map